import { defineStore } from 'pinia'
import { computed, inject, ref } from 'vue'
import axios from 'axios'
import { BACKEND_BASEURL } from '@/config/config'
import { useSnackbarStore } from '@es-bill/es-bill-common-components'
import { useI18n } from 'vue-i18n'

export const useCommunityCompaniesStore = defineStore('communityCompaniesStore', () => {
  const { t } = useI18n()
  const $log = inject('log')
  const snackbarStore = useSnackbarStore()

  const communityCompanies = ref([])
  const communityCompaniesLoading = ref(false)

  const allCommunityCompanies = computed(() => communityCompanies.value)
  const allCommunityCompaniesLoading = computed(() => communityCompaniesLoading.value)

  async function fetchCommunityCompanies() {
    communityCompaniesLoading.value = true;
    communityCompanies.value = [];

    try {
      const response = await axios.get(BACKEND_BASEURL + 'metadata/companiesCM');
      communityCompanies.value = response.data;
      return response.data;
    } catch (error) {
      $log?.warn(error);
      snackbarStore.showSnackbar(t('connectionProblem'), '', 'Warning', 10000, []);
      throw error;
    } finally {
      communityCompaniesLoading.value = false;
    }
  }

  function getCommunityCompany(ecn) {
    const matches = communityCompanies.value.filter((company) => company.ecn === ecn)
    if (matches.length > 0) return matches[0]
    return {
      id: 0,
      name: 'dlt',
      legal: 'dlt',
      members: [],
    }
  }

  // whole document update with __v concurrency check (ESB-637); the metadata
  // response extras are stripped before sending
  async function updateCommunityCompany(ecn, companyData) {
    const { requestorIsMaintainer, memberCount, ...payload } = companyData;
    const response = await axios.put(BACKEND_BASEURL + 'metadata/company/' + ecn, payload);
    const index = communityCompanies.value.findIndex((c) => c.ecn === ecn);
    if (index !== -1)
      communityCompanies.value[index] = { ...communityCompanies.value[index], ...response.data };
    return response.data;
  }

  function getCommunityMember(ecn, clientCode) {
    const community = getCommunityCompany(ecn)
    if (community.ecn === ecn) {
      const members = community.members.filter((member) => member.clientCode === clientCode)
      if (members.length) return members[0]
    }
    return null
  }

  return {
    // state
    allCommunityCompanies,
    allCommunityCompaniesLoading,

    // getters
    getCommunityCompany,
    getCommunityMember,

    // actions
    fetchCommunityCompanies,
    updateCommunityCompany,
  }
})


